import { PaginaCrud } from '../components/PaginaCrud'
import type { Licencia } from '../types'

export default function Licencias() {
  return (
    <PaginaCrud<Licencia>
      titulo="Licencias"
      recurso="licencias"
      llave="id"
      columnas={[
        { campo: 'tipo', titulo: 'Tipo' },
        { campo: 'fechaInicio', titulo: 'Inicio', render: (l) => l.fechaInicio?.split('T')[0] || '-' },
        { campo: 'fechaFin', titulo: 'Fin', render: (l) => l.fechaFin?.split('T')[0] || '-' },
        { campo: 'limiteUsuarios', titulo: 'Limite' },
        { campo: 'activa', titulo: 'Activa', render: (l) => (l.activa ? 'Si' : 'No') },
      ]}
      campos={[
        { nombre: 'tipo', etiqueta: 'Tipo', tipo: 'select', requerido: true, opciones: [{ valor: 'Mensual', texto: 'Mensual' }, { valor: 'Anual', texto: 'Anual' }] },
        { nombre: 'fechaInicio', etiqueta: 'Inicio', tipo: 'texto', requerido: true },
        { nombre: 'fechaFin', etiqueta: 'Fin', tipo: 'texto', requerido: true },
        { nombre: 'limiteUsuarios', etiqueta: 'Limite usuarios', tipo: 'numero', requerido: true },
        { nombre: 'activa', etiqueta: 'Activa', tipo: 'checkbox' },
      ]}
      valorInicial={{ tenantId: 1, activa: true, limiteUsuarios: 5 }}
    />
  )
}
